/*************************************************/
/* ContentBoxes */
/*************************************************/

export function contentBoxes() {
    const containerSelector = '.content-boxes__inner';
    const classToToggle = 'content-boxes__inner__half-content-box';

    const init = () => {
        const containers = document.querySelectorAll(containerSelector);

        containers.forEach(container => {
            const childDivs = container.querySelectorAll(':scope > div');
            const childCount = childDivs.length;

            if (childCount <= 2) {
                container.classList.add(classToToggle);
            } else {
                container.classList.remove(classToToggle);
            }
        });
    };

    init();
}

contentBoxes();
